import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/shared.module';

import { LicenceComponent } from './licence.component';
import { UserEditComponent } from './licence-detail/user-edit/user-edit.component';
import { UsersListComponent } from './licence-detail/users-list/users-list.component';
import { RolesListComponent } from './licence-detail/roles-list/roles-list.component';
import { LicenceEditComponent } from './licence-edit/licence-edit.component';
import { RoleEditComponent } from './licence-detail/role-edit/role-edit.component';
import { LicencesListComponent } from './licences-list/licences-list.component';
import { LicenceDetailComponent } from './licence-detail/licence-detail.component';
import { RouterModule } from '@angular/router';
import { LicenceSummaryComponent } from './licence-detail/licence-summary/licence-summary.component';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { LicenceBillingComponent } from './licence-billing/licence-billing.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        RouterModule,
        FormsModule,
        MatDatepickerModule
    ],
    declarations: [
        LicenceComponent,
        UserEditComponent,
        UsersListComponent,
        RolesListComponent,
        LicenceEditComponent,
        RoleEditComponent,
        LicencesListComponent,
        LicenceDetailComponent,
        LicenceSummaryComponent,
        LicenceBillingComponent
    ],
    providers: [
        MatNativeDateModule,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
    ]
})
export class LicenceModule { }
